import { GoArrowUp } from "react-icons/go"

const SalesDataCard = ({ salesData }) => {
  return (
    <>
      {salesData?.map((item, index) => (
        <div className="border rounded px-3 py-2 mt-3" key={index}>
          <div className="d-flex align-items-center justify-content-between">
            <div className="fw-semibold">{item.title}</div>
            <div className="p-1 rounded d-flex align-items-center gap-1" style={{ backgroundColor: "#ddfce8", color:'#22C55E' }}>
              <GoArrowUp fill="#22C55E" /> {item.value}
            </div>
          </div>

          <div className="mt-2 d-flex align-items-center justify-content-between">
            <div>
              <div className="fs-5 fw-bold">{item.revenue}</div>
              <div>{item.lastYearRevenue}</div>
            </div>
            <div>
              <img src={item.lineImg || ""} alt="" width={70} height={30} />
            </div>
          </div>
        </div>
      ))}
    </>
  )
}

export default SalesDataCard
